import StartListSide from './StartListSide'
import Referees from 'components/general/Referees'
import { useViewport } from 'components/general/useViewPort';
import React from 'react';

const getConfigForCoaches = () => {
    let config = {
        source: 'coach',
        nationality: true,
        avoidDuplicates: true,
        hideNoc: true,
        filter: ['COACH']
    }
    return config

}

const getConfigForReferees = () => {
    let config = {
        source: 'official',
        avoidDuplicates: true
    }
    return config
}

const BscStartList = ({ data }) => {
    const { breakPoint } = useViewport();

    //geting data of home competitor
    let home = data?.results?.items?.find(item =>
        item?.eventUnitEntries?.find(euItem => euItem.eue_code === 'HOME_AWAY' && euItem.eue_value === 'HOME')
    )
    // there is NO event unit entry HOME_AWAY, then guess that HOME is the one's with startSortOrder = 1
    if (home === undefined) {
        home = data?.results?.items?.find(item => item.startSortOrder === 1)
    }

    //geting data of away competitor
    let away = data?.results?.items?.find(item =>
        item?.eventUnitEntries?.find(euItem => euItem.eue_code === 'HOME_AWAY' && euItem.eue_value === 'AWAY')
    )
    // there is NO event unit entry HOME_AWAY, then guess that AWAY is the one's with startSortOrder = 2
    if (away === undefined) {
        away = data?.results?.items?.find(item => item.startSortOrder === 2)
    }
    const resultStatus = data?.results?.status?.code;
    const date = data?.results?.date
    const refereesConf = getConfigForReferees();
    const coachesConf = getConfigForCoaches();

    //Responsive size > md
    const xl = (
        <div className="container">
            <div className="row">
                <div className="col-6">
                    <StartListSide data={home} resultStatus={resultStatus} config={undefined} date={date} />
                </div>
                <div className="col-6">
                    <StartListSide data={away} resultStatus={resultStatus} config={undefined} date={date} />
                </div>
            </div>
            <div className="row">
                <div className="col-6">
                    <Referees data={home?.teamCoaches} config={coachesConf} homeAway="H" noc={home?.participant?.organisation?.code} />
                </div>
                <div className="col-6">
                    <Referees data={away?.teamCoaches} config={coachesConf} homeAway="A" noc={away?.participant?.organisation?.code} />
                </div>
            </div>
            <div className="row">
                <div className="col-12">
                    {data?.results?.officials &&
                        <Referees data={data?.results?.officials} config={refereesConf} />
                    }
                </div>
            </div>
        </div>
    );

    //Responsive xs or sm or md
    const sm = (
        <div className="container">
            <div className="row">
                <div className="col-12">
                    <StartListSide data={home} resultStatus={resultStatus} config={undefined} date={date} />
                </div>
            </div>
            <div className="row">
                <div className="col-12">
                    <Referees data={home?.teamCoaches} config={coachesConf} homeAway="H" noc={home?.participant?.organisation?.code} />
                </div>
            </div>
            <div className="row">
                <div className="col-12">
                    <StartListSide data={away} resultStatus={resultStatus} config={undefined} date={date} />
                </div>
            </div>
            <div className="row">
                <div className="col-12">
                    <Referees data={away?.teamCoaches} config={coachesConf} homeAway="A" noc={away?.participant?.organisation?.code} />
                </div>
            </div>
            <div className="row">
                <div className="col-12">
                    {data?.results?.officials &&
                        <Referees data={data?.results?.officials} config={refereesConf} />
                    }
                </div>
            </div>
        </div>
    );
    return breakPoint !== "xs" && breakPoint !== "sm" && breakPoint !== "md" ? xl : sm

}

export default BscStartList;